import { render, staticRenderFns } from "./SyncMessagesInstance.vue?vue&type=template&id=3105eea9&"
import script from "./SyncMessagesInstance.vue?vue&type=script&lang=js&"
export * from "./SyncMessagesInstance.vue?vue&type=script&lang=js&"
import style0 from "./SyncMessagesInstance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports